import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  images:null,
  loading: false,
  uploadImagesLoading: false,
  deleteImagesLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GALLERY_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
